import ChatIcon from '@mui/icons-material/Chat';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';

export const serviceActivityOptions = [  
  "Assistance",
  "End User",
  "Development",
  "Handbook",
  "Meetings",
  "Quality Issue",
  "Training",
  "Training (Personal)",
  "Warranty",  
];
export const serviceProvisionOptions = [  
  { name: 'Chat', icon: ChatIcon, label: 'Chat', color: '#1976d2' }, 
  { name: 'Email', icon: EmailIcon, label: 'Email', color: '#1976d2' }, 
  { name: 'In Person', icon: PersonIcon, label: 'In Person', color: '#1976d2' }, 
  { name: 'Phone Call', icon: PhoneIcon, label: 'Phone Call', color: '#1976d2' }, 
  { name: 'Remote Desktop', icon: DesktopWindowsIcon, label: 'Remote Desktop', color: '#1976d2' }, 
];
export const serviceIssueOptions = [  
  "PROBLEM: CONNECTION",
  "PROBLEM: DRIVEABILITY",
  "PROBLEM: INSTALLATION",
  "PROBLEM: SOFTWARE",
  "PROBLEM: GENERIC",
  "FEASIBILITY: YES",
  "FEASIBILITY: NO",
  "INFO NON PUBBLICATE",
  "INFO PUBBLICATE",
  "LICENSE",
];
export const systemTypeOptions = [ 
  "PFI",
  "DI",
  "MIXER",
  "DDF",
  "ALARM",
]
export const systemFuelOptions = [ "LPG", "CNG", "n/a" ]
export const systemChannelOptions = [ "AM", "OEM", "0km" ]
export const systemBrandOptions = [ 
  "LANDI", 
  "LOVATO",
  "AEB",
  "EMMEGAS",
  "MED",
]
